<button
  class="border-s500 h-7 w-7 rounded border-2 align-middle focus:outline-none"
  [ngStyle]="{ 'background-color': color }"
  #t1="tippy"
  [tp]="templateColor"
  [tpHideOnEscape]="true"
  tpVariation="menu"
  placement="right-start"
  className="my-menu"
>
  <div *ngIf="!color">U</div>
</button>

<ng-template #templateColor>
  <div class="border-s4 bg-m0 w-56 rounded-md border-2 shadow-xl">
    <color-sketch
      [color]="rgbaColor"
      (onChangeComplete)="onChangeComplete($event)"
    ></color-sketch>

    <div class="bg-m0 flex flex-row justify-between">
      <button
        class="bg-m600 text-m0 block rounded px-3 py-2 text-sm font-medium focus:outline-none"
        (click)="t1.hide(); save()"
        >Save</button
      >

      <button
        class="bg-m600 text-m0 block rounded px-3 py-2 text-sm font-medium focus:outline-none"
        (click)="t1.hide(); cancel()"
        >Cancel</button
      >

      <button
        class="bg-m600 text-m0 block rounded px-3 py-2 text-sm font-medium focus:outline-none"
        (click)="t1.hide(); clear()"
        >Undef</button
      >
    </div>
  </div>
</ng-template>
